import cn from 'classnames';
import parse from 'html-react-parser';
import { FC } from 'react';

import {
  cleanBuilderParagraphInput,
  cleanBuilderStringInput,
  getBuilderString,
  isBuilderStringPresent,
} from '@/shared/text';
import { BuilderString } from '@/shared/types';

import { Action } from '../Action';
import style from './Content.module.scss';

export const MOCK_DESCRIPTION =
  'Section description indicating the content to be foundand presented here with a medium legth copy block.';

interface Props {
  headline?: string;
  description?: BuilderString;
  action: Action;
  locale: string;
}
export const Content: FC<Props> = ({
  headline,
  description,
  action,
  locale,
}) => (
  <div
    data-testid="highlight-content"
    className={cn(
      'tw:flex',
      'tw:flex-1',
      'tw:flex-col',
      'tw:justify-center',
      style.content
    )}
  >
    <div className={style.text}>
      {isBuilderStringPresent(headline, locale) ? (
        <div
          data-testid="headline"
          className={cn('u-typography-h2', {
            'u-m-b-m u-m-b-md-xl u-m-b-lg-xl':
              action.variant !== 'none' ||
              isBuilderStringPresent(description, locale),
          })}
        >
          {parse(cleanBuilderStringInput(getBuilderString(headline, locale)))}
        </div>
      ) : null}
      {isBuilderStringPresent(description, locale) ? (
        <div
          data-testid="description"
          className={cn('u-typography-h4', 'tw:text-neutral-secondary', {
            'u-m-b-m u-m-b-md-xl u-m-b-lg-xl': action.variant !== 'none',
          })}
        >
          {parse(
            cleanBuilderParagraphInput(getBuilderString(description, locale))
          )}
        </div>
      ) : null}
      <Action {...action} />
    </div>
  </div>
);
